import { FormFieldAutocomplete } from '@/global/components/Form'
import { funcao_api } from '@/service/api'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

export default function AutocompleteFuncao() {
    const { setValue } = useFormContext()

    const { data = [] } = funcao_api.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })

    const [busca, setBusca] = useState('')
    const digitado = busca.trim()
    const jaExiste = data.some(
        funcao => funcao.toLowerCase() === digitado.toLowerCase(),
    )

    return (
        <FormFieldAutocomplete
            name="funcao"
            label="Cargo/Função"
            required
            options={data}
            onInputChange={setBusca}
            searchPlaceholder="Buscar ou digitar para criar uma função"
            noOptionsText="Digite para criar um novo"
            creatableOption={
                digitado && !jaExiste
                    ? {
                          label: `Criar: ${digitado}`,
                          onClick: () => {
                              // Entra na lista em memória para que a função
                              // apareça selecionada e continue disponível nos
                              // outros campos da tela.
                              funcao_api.setQueryData<string[]>(
                                  undefined,
                                  prev =>
                                      prev ? [digitado, ...prev] : [digitado],
                              )
                              setValue('funcao', digitado, {
                                  shouldValidate: true,
                                  shouldDirty: true,
                              })
                          },
                      }
                    : undefined
            }
        />
    )
}
